import { formatPrice } from "../utils/format";
import ProductQuantityControls from "./productQuantityControls";
import { CartProductItem } from "./styles";

function CartItem({ product }) {
  return (
    <CartProductItem>
      <div className="cart-item__name">{product.name}</div>
      <div className="cart-item__row">
        <div className="cart-item__price">{formatPrice(product.price)} zł</div>
        <ProductQuantityControls
          productId={product.id}
          productName={product.name}
          quantity={product.qty}
        />
      </div>
    </CartProductItem>
  );
}

export default CartItem;
